var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-action",class:{
    'is-large': _vm.isLarge,
    'is-disabled': _vm.isDisabled,
    'has-thumbnail': !!_vm.data.thumbnail,
    'has-content': !!_vm.data.content,
    'animate__animated animate__shakeX': _vm.isInactive && !_vm.isFocused
  },on:{"click":_vm.validate}},[(_vm.data.thumbnail)?_c('el-image',{attrs:{"src":_vm.data.thumbnail,"alt":"Véhicule","fit":"cover"}}):_vm._e(),_c('strong',[_c('span',[_vm._v(_vm._s(_vm.data.label || ''))])]),(_vm.data.content)?_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.data.content))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }